import React from 'react';

export const DashboardOverview = ({ data }) => {
    // Debug: Track when props change
    React.useEffect(() => {
        if (data?.overall_statistics?.total_fee_collected?.breakdown) {
            // console.log('📊 DashboardOverview received updated data - cheque value:',
            //     data.overall_statistics.total_fee_collected.breakdown.cheque);
        }
    }, [data]);

    if (!data) {
        return (
            <div className="section-card">
                <h2>Dashboard Overview</h2>
                <div className="loading-placeholder">Loading...</div>
            </div>
        );
    }

    const { date_range, overall_statistics } = data;

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    const formatDate = (dateStr) => {
        return new Date(dateStr).toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    // Add null checks for date_range
    if (!date_range || !overall_statistics) {
        return (
            <div className="section-card">
                <h2>Dashboard Overview</h2>
                <div className="loading-placeholder">Loading data...</div>
            </div>
        );
    }

    // Add null checks for nested properties
    const feeCollected = overall_statistics.total_fee_collected || {};
    const breakdown = feeCollected.breakdown || {};
    const reconciliationSummary = overall_statistics.reconciliation_summary || {};
    const unreconciled = reconciliationSummary.unreconciled || {};
    const reconciled = reconciliationSummary.reconciled || {};

    return (
        <div className="section-card">
            <div className="section-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h2 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    Today's Overview  
                </h2>
                <div className="date-range">
                    {date_range.is_today_only ? (
                        <span>Today ({formatDate(date_range.start_date)})</span>
                    ) : (
                        <span>
                            {formatDate(date_range.start_date)} - {formatDate(date_range.end_date)}
                            ({date_range.total_days} days)
                        </span>
                    )}
                </div>
            </div>


            <div className="overview-grid">
                {/* Fee Collection Section */}
                <div className="overview-section">
                    <div className="section-title">
                        <h3>Fee Collection</h3>
                        <div className="collection-summary">
                            <span className="total-amount">
                                {formatCurrency(feeCollected.amount || 0)}
                            </span>
                            <span className="total-count">
                                ({feeCollected.count || 0} transactions)
                            </span>
                        </div>
                    </div>

                    <div className="breakdown-cards">
                        <div className="breakdown-card cash">
                            <span className="method">Cash</span>
                            <span className="amount">
                                {formatCurrency(breakdown.cash || 0)}
                            </span>
                        </div>
                        <div className="breakdown-card cheque">
                            <span className="method">Cheque</span>
                            <span className="amount">
                                {formatCurrency(breakdown.cheque || 0)}
                            </span>
                        </div>
                        <div className="breakdown-card dd">
                            <span className="method">DD</span>
                            <span className="amount">
                                {formatCurrency(breakdown.dd || 0)}
                            </span>
                        </div>
                        <div className="breakdown-card neft">
                            <span className="method">NEFT/RTGS</span>
                            <span className="amount">
                                {formatCurrency(breakdown.neft_rtgs || 0)}
                            </span>
                        </div>
                    </div>

                    {feeCollected.last_payment && (
                        <div className="last-payment">
                            <small>
                                Last payment: {new Date(feeCollected.last_payment).toLocaleString('en-IN')}
                            </small>
                        </div>
                    )}
                </div>

                {/* Reconciliation Section */}
                <div className="overview-section">
                    <div className="section-title">
                        <h3>Reconciliation Summary</h3>
                        {/* <div className="reconciliation-ratio">
                            <span className="ratio-label">Collection:Reconciliation Ratio</span>
                            <span className="ratio-value">
                                1:{(overall_statistics.collection_reconciliation_ratio || 0).toFixed(1)}
                            </span>
                        </div> */}
                    </div>

                    <div className="reconciliation-stats">
                        <div className="recon-card unreconciled">
                            <div className="card-header">
                                <span className="status-icon">⏳</span>
                                <span className="status-text">Unreconciled</span>
                            </div>
                            <div className="card-content">
                                <div className="amount">
                                    {formatCurrency(unreconciled.total_amount || 0)}
                                </div>
                                <div className="count">
                                    {unreconciled.total_count || 0} items
                                </div>
                            </div>
                        </div>

                        <div className="recon-card reconciled">
                            <div className="card-header">
                                <span className="status-icon">✅</span>
                                <span className="status-text">Reconciled</span>
                            </div>
                            <div className="card-content">
                                <div className="amount">
                                    {formatCurrency(reconciled.total_amount || 0)}
                                </div>
                                <div className="count">
                                    {reconciled.total_count || 0} items
                                </div>
                                <div className="success-breakdown">
                                    <small>
                                        Success: {formatCurrency(reconciled.success_amount || 0)}
                                        ({reconciled.success_count || 0})
                                    </small>
                                    {(reconciled.reject_count || 0) > 0 && (
                                        <small>
                                            Rejected: {formatCurrency(reconciled.reject_amount || 0)}
                                            ({reconciled.reject_count || 0})
                                        </small>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
